import { Typography } from '@components/Typography';

export const SectionTitle = ({ children, sx }) => (
    <Typography variant="subtitle1" sx={{ color: 'var(--text-primary)', ...sx }}>
        {children}
    </Typography>
);

export const Hint = ({ children, sx }) => (
    <Typography variant="caption" sx={{ color: 'var(--text-secondary)', display: 'block', ...sx }}>
        {children}
    </Typography>
);
